<template>
  <div>   
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
<!--           <th scope="col"></th> -->
        </tr>
      </thead>
      <tbody>
        <tr v-for="empresaimg in datosPaginados" :key="empresaimg.idEmpresaImg">
          <td><img @click="abrirModalEditar(empresaimg.idEmpresaImg)"
                   :src="direccionImagen(empresaimg.idEmpresaImg)"
                   :style="estiloImagen"
                   style="font-size:16px;color:orangered; cursor: pointer;"
                   title="Editar"/>
          </td>          

<!--           <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteEmpresaImg(empresaimg.idEmpresaImg)" title="Borrar">delete</i></td> -->
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPaginaTodos(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idEmpresa" class="form-label">IdEmpresa</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idEmpresa" name="idEmpresa" v-model="datoEmpresaImg.idEmpresa" disabled>
                </div>
              </div>
            </div>

            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idEmpresaImg" class="form-label">IdEmpresaImg</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idEmpresaImg" name="idEmpresaImg" v-model="datoEmpresaImg.idEmpresaImg" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="imagen" class="form-label">Imagen</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="imagen" name="imagen" v-model="datoEmpresaImg.imagen" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Imagen</label>
                </div>
                <div class="col-10">
                  <img :src="direccionImagen(datoEmpresaImg.idEmpresaImg)" :style="estiloImagen"/>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="imagen" class="form-label">Imagen</label>
                </div>
                <div class="col-10">
                <input type="file" class="form-control" id="imagenCarga" name="imagenCarga" accept="image/*" @change="handleFileUpload">
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="nombre" name="nombre" v-model="datoEmpresaImg.nombre" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tipo" class="form-label">Tipo</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="tipo" name="tipo" v-model="datoEmpresaImg.tipo" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarEmpresaImg" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditEmpresaImg" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
  </div>
</template>
<script>
import { validarForm } from '@/modules/validacionesForms.js'
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from 'sweetalert'
export default {
  props: {
    p_idEmpresa: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      empresaimgs : [],
      datoEmpresaImg : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  mounted () {
    this.getDataPaginaTodos(this.paginaActual)
  },
  methods : {
    direccionImagen(codigo){
      return `http://localhost:8080/api/v1/empresaimgs/${codigo}`;
    },
    async handleFileUpload(event) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append("image", file);
      await api.post('/empresaimgs/'+this.datoEmpresaImg.idEmpresa, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
      .then(response => {
        // Manejar la respuesta del backend
        console.log("Archivo subido exitosamente"+response);
      })
      .catch(error => {
        // Manejar errores
        console.error("Error al subir el archivo", error.response.data);
      });
    },
    totalPaginas(){
      return Math.ceil(this.empresaimgs.length / this.elementosPorPagina)
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwempresaimgs').then(response=>{
      this.empresaimgs=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.empresaimgs.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'imagen'
        ,'nombre'
        ,'tipo'
      ];
      const requiredFieldsText = [
        'idEmpresa'
        ,'imagen'
        ,'nombre'
        ,'tipo'
      ];
      return validarForm(this.datoEmpresaImg, requiredFields, requiredFieldsText);
    },
    async guardarEmpresaImg(){
      if(this.validarForm() === 1){        
        try {
          this.datoEmpresaImg.idEmpresa = window.sessionStorage.getItem("idEmpresa");
          await api.post('/empresaimgs', this.datoEmpresaImg)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "EmpresaImg creada exitosamente!", "success");
          this.getDataPaginaTodos(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditEmpresaImg(){
      if(this.validarForm() === 1){
        try {
          await api.post('/empresaimgs', this.datoEmpresaImg)
          $('#ventanaModal').modal('hide');
          this.getDataPaginaTodos(this.paginaActual);
          swal("Correcto!", "EmpresaImg creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoEmpresaImg={}
      this.titulo   = 'Crear Empresa: Imagen'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirModalEditar(idEmpresaImg){
      this.modalWindow = true
      if(idEmpresaImg != null){    
           api.get('/vwempresaimgs/'+idEmpresaImg).then(resp=>{
          this.datoEmpresaImg = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Empresa: Imagen'
      this.btnCrear = false
      this.btnEditar= true
    },
/*     async deleteEmpresaImg (idEmpresaImg) {
      try{
        await api.delete('/empresaimgs/'+idEmpresaImg)
          this.getDataPaginaTodos(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    }, */
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
